export default __webpack_public_path__ + "static/media/tabRight.11d8b7ad.png";